module.exports = __webpack_public_path__ + "static/img/product_society_society_yjgl2.b6e319b.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_society_society_yjgl2.svg
// module id = tbtc
// module chunks = 0